import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { SubmitToEwaFormOption } from '../../models/submit-to-ewa-form-option';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-submit-to-ewa-form-option',
    templateUrl: './submit-to-ewa-form-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCardModule, MatButtonModule],
})
export class SubmitToEwaFormOptionComponent {
    @Input() formOption!: SubmitToEwaFormOption;
    @Input() hasErrorHighlight: boolean = false;
    @Input() selected: boolean = false;
    @Input() disabled: boolean = false;
    @Output() serviceSelected = new EventEmitter<SubmitToEwaFormOption>();

    onServiceSelected(): void {
        if (this.disabled) {
            return;
        }
        this.serviceSelected.emit(this.formOption);
    }
}
